module.exports = new __parcel__URL__("FollowCursorOnboardingHeader.4193dac1.svg").toString();